<template>
	<transition name="grow" @before-enter="beforeEnter" @after-enter="afterEnter" @before-leave="beforeLeave" @after-leave="afterLeave" >
		<slot />
	</transition>
</template>

<script>
	export default {
		data() {
			return {
				_paddingTop: false,
				_paddingBottom: false,
			}
		},
		methods: {
			beforeEnter(el) {
				// Setup clone
				var clone = el.cloneNode(true),
					h;
				clone.style.width = el.style.width;
				clone.style.visibility = "hidden";
				clone.style.removeProperty("display");

				// if inner animation (might be undesired)
				var desc = clone.querySelectorAll("*");
				[].forEach.call(desc, function(item) {
					// remove possible inline styles of display(=none)
					item.style.removeProperty("display");
				});

				// get clone height
				el.parentNode.appendChild(clone);
				h = clone.clientHeight;
				clone.remove();

				// Force animation instead of simple "setting a height"
				el.style.height = "0px";
				if (el.style.paddingTop) {
					this._paddingTop = el.style.paddingTop;
					el.style.paddingTop = "0px";
				}
				if (el.style.paddingBottom) {
					this._paddingBottom = el.style.paddingBottom;
					el.style.paddingBottom = "0px";
				}
				// setTimeout(() => (el.style.height = h + "px"), 1);
				// el.getBoundingClientRect();
				requestAnimationFrame(()=>{
					requestAnimationFrame(()=>{
						el.style.height = h + "px";
						if (this._paddingTop !== false) {
							el.style.paddingTop = this._paddingTop;
							this._paddingTop = false;
						}
						if (this._paddingBottom !== false) {
							el.style.paddingBottom = this._paddingBottom;
							this._paddingBottom = false;
						}
					})
				})
			},
			afterEnter(el) {
				el.style.removeProperty("height");
			},
			beforeLeave(el) {
				el.style.height = el.clientHeight + "px";
				// setTimeout(() => (el.style.height = "0px"), 1);
				// el.getBoundingClientRect();
				requestAnimationFrame(()=>{
					requestAnimationFrame(()=>{
						el.style.height = "0px";
						if (el.style.paddingTop) {
							this._paddingTop = el.style.paddingTop;
							el.style.paddingTop = "0px";
						}
						if (el.style.paddingBottom) {
							this._paddingBottom = el.style.paddingBottom;
							el.style.paddingBottom = "0px";
						}
					})
				})
			},
			afterLeave(el) {
				el.style.removeProperty("height");
				if (this._paddingTop !== false) {
					el.style.paddingTop = this._paddingTop;
					this._paddingTop = false;
				}
				if (this._paddingBottom !== false) {
					el.style.paddingBottom = this._paddingBottom;
					this._paddingBottom = false;
				}
			}
		}
	};
</script>

<style>
	.grow-enter-active,
	.grow-leave-active {
		transition: all .2s ease-out;
		overflow: hidden;
	}
</style>